import { useState } from 'react';

import StudentsDataListTable from 'entities/Dataset/components/StudentsDataListTable';
import StudentsListFilters from 'entities/Dataset/components/StudentsListFilters';
import {
  StudentsDataListFilterProps,
  getStudentsDatasetExportURL,
  useStudentsDatasetList,
  useUsStates
} from 'entities/Dataset/sdk';

import Text from 'components/Text';

const DEFAULT_PAGE_SIZE = 10;

const StudentRepositoryPage = () => {
  const [filters, setFilters] = useState<StudentsDataListFilterProps>({
    gender: '',
    grade: '',
    ethnicity: '',
    state: '',
    is_low_income: '',
    is_on_individualized_education_plan: '',
    assignment_name: '',
    standard_code: '',
    english_learner_status: '',
    limit: DEFAULT_PAGE_SIZE,
    offset: 0
  });

  const { data: studentsDataList, isLoading: isLoadingStudentsDataList } =
    useStudentsDatasetList({ filters });

  const { data: usStates } = useUsStates();

  const handleExport = () => {
    const exportURL = getStudentsDatasetExportURL({ filters });

    window.location.href = exportURL;
  };

  return (
    <div className="flex w-full flex-col gap-5 px-4 py-6 sm:px-6 md:px-10">
      <Text variant="h4">Welcome to EdLight's Research Portal</Text>
      <Text variant="subtitle1">
        Providing high-quality images of student work to improve learning and
        confidence in math for all students.
      </Text>
      <Text variant="subtitle2">
        As of August 2025, the repository includes work from Grades 6–8 students
        in three states: Illinois, Washington, and Rhode Island. This
        repository’s collection of student work is ongoing and iterative.
      </Text>
      <StudentsListFilters
        usStates={usStates}
        filters={filters}
        onFilter={setFilters}
        handleExport={handleExport}
      />

      <Text variant="subtitle1">
        ⚠️ Note that we've removed the ability to find data for subgroups
        smaller than 10 students!
      </Text>

      <StudentsDataListTable
        studentsDataList={studentsDataList}
        isLoadingStudentsDataList={isLoadingStudentsDataList}
        filters={filters}
        onFilter={setFilters}
      />
    </div>
  );
};

export default StudentRepositoryPage;
